// eslint-disable-next-line no-use-before-define
import React, { Component } from 'react';
import { UKNavBar } from 'op-components';
import OutageBanner from 'op-components/Banner/Outage';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import './UKHomePage.scss';
import { gql } from '@apollo/client';
import { OPUser } from 'op-interfaces';
import { LoadingSpinner } from 'shared-components/components';
import { Query } from '@apollo/client/react/components';
import SSOPage from 'op-pages/Shared/SSOPage/SSOPage';

interface UserDetailsQueryData {
  user: OPUser;
}

export const USER_DETAILS_QUERY = gql`
  query UserDetails {
    user {
      id
      isPso
      firstName
      lastName
    }
  }
`;

interface State {
  isActive?: boolean;
}

interface Props extends RouteComponentProps {
  routes: any;
}

class UKHomePage extends Component<Props, State> {
  public constructor(props: Props) {
    super(props);
    this.state = {};
  }

  public render(): JSX.Element {
    const { routes } = this.props;
    return (
      <Query<UserDetailsQueryData> query={USER_DETAILS_QUERY}>
        {({ loading, data, error }): JSX.Element => {
          if (loading) {
            return <LoadingSpinner />;
          }
          // Session expiry (401/403) is redirected to /sso/login by the Apollo error link and any
          // other GraphQL error opens the global error modal, so an error here must not
          // re-authenticate through SSOPage - stay on the current page instead.
          if (!error && !data?.user) {
            // No error and no user means the session is not authenticated
            return <SSOPage />;
          }
          if (window.location.pathname.includes('/radiation')) {
            //open RO portal
            return routes;
          }
          //open Quarantini or eRego
          return (
            <div id="homepage-wrapper">
              <div className="header-wrapper">
                <OutageBanner />
                <UKNavBar />
              </div>
              <div className="body-wrapper">
                <div className="content-wrapper">{routes}</div>
              </div>
            </div>
          );
        }}
      </Query>
    );
  }
}

export default withRouter(UKHomePage);
